import SpriteSymbol from "../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-07jurassic_VerCenter_fenbu",
  "use": "icon-07jurassic_VerCenter_fenbu-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-07jurassic_VerCenter_fenbu\"><path d=\"M64 259h896v64H64zM64 672h896v64H64z\" fill=\"#727272\" /><path d=\"M320 192h384v192H320z\" fill=\"#B3B3B3\" /><path d=\"M192 576h640v256H192z\" fill=\"#497CAD\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol